






























import EstablishmentLogo from '@/components/EstablishmentLogo.vue'
import gql from '../gqlService.coffee'
import Fuse from 'fuse.js'

export default {
    "name": 'EstablishmentList',
    "components": {EstablishmentLogo}
    "props": {
        "title": false
        "selectable": Boolean
        "autoload": false
        "height": String
        "filters": {
            "type": Object,
            "default": ()->
                return {
                    negative: false
                    positive: false
                    search_string: ""
                }
        }
    },
    "computed":
        "filtered_establishment_set": ()->
            vm = @
            if vm.filters.search_string != ""
                fuse = new Fuse(vm.establishment_set.results, {
                    keys:[{
                        name: "name"
                    }]
                })
                result = fuse.search(vm.filters.search_string)
            else
                result = vm.establishment_set.results            
            return result
        "computed_filters": ()->
            res = "active: true"
            if this.$store.state.selected_consultant_uid?
                res += "consultant__uid: \"#{this.$store.state.selected_consultant_uid}\""

            return res
    "data": ()->
        self = @
        return {
            "loading": true,
            "establishment_set": new gql.DataHolder({
                "model": "establishment_set",
                "fields": "uid name logo",
                "autoload": this.autoload,
                "filters": {active:true}
            })
        }
    "methods":
        "select": (item)->
            if this.selectable
                this.$router.push({"name": "establishment", "params": {'uid': item.uid}})
    "mounted": ()->
        vm = @
        this.establishment_set.promise.then ()->
            vm.loading = false
            if !vm.$route.params.uid and vm.establishment_set.results.length > 0
                vm.$router.push({"name": "establishment", "params": {'uid': vm.establishment_set.results[0]['uid']}})
        if @$route.params.uid?
            this.$store.commit("select_establishment", @$route.params.uid)
        return
    "beforeDestroy": ()->
        this.$store.commit("select_establishment", null)
    "watch":
        "filters.consultant": (newV, oldV)->
            self = @

            if newV? and newV != oldV
                self.loading = true
                if newV.uid?
                    self.establishment_set.query({'consultant__uid':newV.uid, active:true}).then ()->
                        self.loading = false
                else
                    self.establishment_set.clearFilters()
                    self.establishment_set.query({active:true}).then ()->
                        self.loading = false

        "$store.state.selected_consultant_uid": (newV, oldV)->
            self = @
            self.loading = true
            if newV
                self.establishment_set.query({'consultant__uid':newV, active:true}).then ()->
                    self.loading = false
        "$route.params": (newV, oldV)->
            if newV.uid != oldV.uid
                this.$store.commit("select_establishment", newV.uid)
}
